// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "td {\n  padding: 4px;\n}\n\ntd input {\n  width: 232px;\n}", "",{"version":3,"sources":["webpack://./src/app/pages/master/posts/posts.component.scss"],"names":[],"mappings":"AAAA;EACI,YAAA;AACJ;;AAEE;EACE,YAAA;AACJ","sourcesContent":["td {\r\n    padding: 4px;\r\n  }\r\n  \r\n  td input {\r\n    width: 232px;\r\n  }\r\n  "],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
